/* eslint-disable no-console */
import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { init } from '@module-federation/enhanced/runtime';

let federatedHost = null;
function initFederatedHost(config) {
  if (federatedHost) {
    return federatedHost;
  }
  federatedHost = init({
    name: 'host',
    remotes: [
      {
        name: 'remote_check',
        entry: config.scheduleRemoteCheckScriptPath,
        type: 'var',
      },
    ],
    inBrowser: true,
  });
  return federatedHost;
}

function useRemoteModuleInjection(rcRemoteModuleKey, rcData, config) {
  React.useEffect(() => {
    let unmounted = false;
    const injectRemoteModule = async () => {
      const host = initFederatedHost(config);
      const remoteCheckPatientPod = await host.loadRemote(
        'remote_check/patient_pod',
      );
      if (unmounted) {
        return () => {};
      }
      const cleanup = remoteCheckPatientPod.inject(
        rcRemoteModuleKey,
        rcData,
      );
      return cleanup;
    };
    const injectRemoteModulePromise = injectRemoteModule().catch(
      (error) =>
        console.error(
          'remote check pod module failed to inject',
          error,
        ),
    );
    return () => {
      unmounted = true;
      injectRemoteModulePromise
        .then((cleanup) => cleanup())
        .catch((error) =>
          console.error(
            'remote check pod module failed to clean up',
            error,
          ),
        );
    };
  }, [rcRemoteModuleKey]);
}

const RC_CONTAINER_ID = 'rc__container';
export const ScheduleRemoteCheck = ({
  rcData,
  rcRemoteModuleKey,
  config,
}) => {
  const remoteCheckPatientPodId = `${RC_CONTAINER_ID}__${rcRemoteModuleKey}`;
  useRemoteModuleInjection(remoteCheckPatientPodId, rcData, config);
  return (
    <div id={remoteCheckPatientPodId} key={remoteCheckPatientPodId} />
  );
};
